// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar Navigation */
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 260px;
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 50%, #0f0f1a 100%);
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  transition: transform 0.3s ease, width 0.3s ease;
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar.closed {
  transform: translateX(-260px);
}

/* Mobile Toggle Button */
.sidebar-toggle {
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 1001;
  background: #5865F2;
  border: none;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  box-shadow: 0 2px 10px rgba(88, 101, 242, 0.3);
  transition: all 0.3s ease;
}

.sidebar-toggle:hover {
  background: #4752c4;
  transform: scale(1.05);
}

/* Brand */
.sidebar-brand {
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.brand-icon {
  font-size: 1.8rem;
}

.brand-text {
  font-size: 1.25rem;
  font-weight: 700;
  background: linear-gradient(135deg, #5865F2, #eb459e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* User Info */
.sidebar-user {
  padding: 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: rgba(88, 101, 242, 0.1);
  margin: 1rem;
  border-radius: 12px;
  border: 1px solid rgba(88, 101, 242, 0.2);
}

.user-avatar-wrapper {
  position: relative;
}

.user-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 2px solid #5865F2;
  object-fit: cover;
}

.user-avatar-icon {
  font-size: 44px;
  color: #5865F2;
}

.user-status {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  background: #43b581;
  border-radius: 50%;
  border: 2px solid #1a1a2e;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  overflow: hidden;
}

.username {
  font-weight: 600;
  color: #ffffff;
  font-size: 0.95rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-badge {
  background: linear-gradient(90deg, #ec4899, #ef4444);
  color: #ffffff;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  font-size: 0.65rem;
  font-weight: 700;
  width: fit-content;
  letter-spacing: 0.5px;
}

/* Sidebar Menu */
.sidebar-menu {
  flex: 1 1;
  padding: 0.5rem;
  overflow-y: auto;
}

/* Navigation Category */
.nav-category {
  margin-bottom: 0.5rem;
}

.category-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  color: #8b8b9a;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.category-header:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
}

.category-header.has-active {
  color: #5865F2;
}

.category-icon {
  font-size: 0.9rem;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.category-label {
  flex: 1 1;
  text-align: left;
}

.category-arrow {
  font-size: 0.7rem;
  transition: transform 0.2s ease;
}

/* Category Items */
.category-items {
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease;
}

.category-items.expanded {
  max-height: 500px;
  opacity: 1;
}

.category-items.collapsed {
  max-height: 0;
  opacity: 0;
}

/* Navigation Item */
.nav-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 1rem 0.7rem 2.5rem;
  color: #b4b4c4;
  text-decoration: none;
  border-radius: 8px;
  margin: 0.15rem 0;
  transition: all 0.2s ease;
  font-size: 0.9rem;
  font-weight: 500;
}

.nav-item:hover {
  background: rgba(88, 101, 242, 0.15);
  color: #ffffff;
  transform: translateX(4px);
}

.nav-item.active {
  background: linear-gradient(90deg, rgba(88, 101, 242, 0.3), rgba(88, 101, 242, 0.1));
  color: #5865F2;
  border-left: 3px solid #5865F2;
  padding-left: calc(2.5rem - 3px);
}

.nav-item.active .item-icon {
  color: #5865F2;
}

.item-icon {
  font-size: 1rem;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8b8b9a;
  transition: color 0.2s ease;
}

.nav-item:hover .item-icon {
  color: #5865F2;
}

.item-label {
  white-space: nowrap;
}

/* Sidebar Footer */
.sidebar-footer {
  padding: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: auto;
}

.logout-btn {
  width: 100%;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.3);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background: #ef4444;
  color: #ffffff;
  border-color: #ef4444;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
}

/* Sidebar Overlay (Mobile) */
.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Scrollbar Styling */
.sidebar::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar::-webkit-scrollbar-thumb {
  background: rgba(88, 101, 242, 0.3);
  border-radius: 3px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(88, 101, 242, 0.5);
}

/* Responsive */
@media (max-width: 1024px) {
  .sidebar-toggle {
    display: flex;
  }

  .sidebar.open {
    transform: translateX(0);
  }

  .sidebar-overlay {
    display: block;
  }
}

@media (max-width: 768px) {
  .sidebar {
    width: 280px;
  }

  .sidebar-user {
    margin: 0.75rem;
    padding: 1rem;
  }

  .user-avatar {
    width: 38px;
    height: 38px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Navbar.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,aAAa;EACb,YAAY;EACZ,0EAA0E;EAC1E,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oDAAoD;EACpD,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,oFAAoF;EACpF,cAAc;EACd,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,cAAc;EACd,wCAAwC;EACxC,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Sidebar Navigation */\n.sidebar {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 260px;\n  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 50%, #0f0f1a 100%);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  transition: transform 0.3s ease, width 0.3s ease;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.sidebar.closed {\n  transform: translateX(-260px);\n}\n\n/* Mobile Toggle Button */\n.sidebar-toggle {\n  position: fixed;\n  top: 1rem;\n  left: 1rem;\n  z-index: 1001;\n  background: #5865F2;\n  border: none;\n  color: white;\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  box-shadow: 0 2px 10px rgba(88, 101, 242, 0.3);\n  transition: all 0.3s ease;\n}\n\n.sidebar-toggle:hover {\n  background: #4752c4;\n  transform: scale(1.05);\n}\n\n/* Brand */\n.sidebar-brand {\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.brand-icon {\n  font-size: 1.8rem;\n}\n\n.brand-text {\n  font-size: 1.25rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #5865F2, #eb459e);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* User Info */\n.sidebar-user {\n  padding: 1.25rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: rgba(88, 101, 242, 0.1);\n  margin: 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba(88, 101, 242, 0.2);\n}\n\n.user-avatar-wrapper {\n  position: relative;\n}\n\n.user-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: 2px solid #5865F2;\n  object-fit: cover;\n}\n\n.user-avatar-icon {\n  font-size: 44px;\n  color: #5865F2;\n}\n\n.user-status {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 12px;\n  height: 12px;\n  background: #43b581;\n  border-radius: 50%;\n  border: 2px solid #1a1a2e;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  overflow: hidden;\n}\n\n.username {\n  font-weight: 600;\n  color: #ffffff;\n  font-size: 0.95rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-badge {\n  background: linear-gradient(90deg, #ec4899, #ef4444);\n  color: #ffffff;\n  padding: 0.15rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  width: fit-content;\n  letter-spacing: 0.5px;\n}\n\n/* Sidebar Menu */\n.sidebar-menu {\n  flex: 1;\n  padding: 0.5rem;\n  overflow-y: auto;\n}\n\n/* Navigation Category */\n.nav-category {\n  margin-bottom: 0.5rem;\n}\n\n.category-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  background: transparent;\n  border: none;\n  color: #8b8b9a;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.category-header:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n}\n\n.category-header.has-active {\n  color: #5865F2;\n}\n\n.category-icon {\n  font-size: 0.9rem;\n  width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.category-label {\n  flex: 1;\n  text-align: left;\n}\n\n.category-arrow {\n  font-size: 0.7rem;\n  transition: transform 0.2s ease;\n}\n\n/* Category Items */\n.category-items {\n  overflow: hidden;\n  transition: max-height 0.3s ease, opacity 0.3s ease;\n}\n\n.category-items.expanded {\n  max-height: 500px;\n  opacity: 1;\n}\n\n.category-items.collapsed {\n  max-height: 0;\n  opacity: 0;\n}\n\n/* Navigation Item */\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.7rem 1rem 0.7rem 2.5rem;\n  color: #b4b4c4;\n  text-decoration: none;\n  border-radius: 8px;\n  margin: 0.15rem 0;\n  transition: all 0.2s ease;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.nav-item:hover {\n  background: rgba(88, 101, 242, 0.15);\n  color: #ffffff;\n  transform: translateX(4px);\n}\n\n.nav-item.active {\n  background: linear-gradient(90deg, rgba(88, 101, 242, 0.3), rgba(88, 101, 242, 0.1));\n  color: #5865F2;\n  border-left: 3px solid #5865F2;\n  padding-left: calc(2.5rem - 3px);\n}\n\n.nav-item.active .item-icon {\n  color: #5865F2;\n}\n\n.item-icon {\n  font-size: 1rem;\n  width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #8b8b9a;\n  transition: color 0.2s ease;\n}\n\n.nav-item:hover .item-icon {\n  color: #5865F2;\n}\n\n.item-label {\n  white-space: nowrap;\n}\n\n/* Sidebar Footer */\n.sidebar-footer {\n  padding: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  margin-top: auto;\n}\n\n.logout-btn {\n  width: 100%;\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  font-weight: 600;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.logout-btn:hover {\n  background: #ef4444;\n  color: #ffffff;\n  border-color: #ef4444;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);\n}\n\n/* Sidebar Overlay (Mobile) */\n.sidebar-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n/* Scrollbar Styling */\n.sidebar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar::-webkit-scrollbar-thumb {\n  background: rgba(88, 101, 242, 0.3);\n  border-radius: 3px;\n}\n\n.sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(88, 101, 242, 0.5);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .sidebar-toggle {\n    display: flex;\n  }\n\n  .sidebar.open {\n    transform: translateX(0);\n  }\n\n  .sidebar-overlay {\n    display: block;\n  }\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    width: 280px;\n  }\n\n  .sidebar-user {\n    margin: 0.75rem;\n    padding: 1rem;\n  }\n\n  .user-avatar {\n    width: 38px;\n    height: 38px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
